// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"179":"components","237":"pages","675":"extra","796":"tables"}[chunkId] || chunkId) + "." + {"152":"46007f6d","179":"a7551d6b","237":"1bd7dde9","479":"4368d9d0","675":"86e3a235","796":"3412a943"}[chunkId] + ".css";
};